import styled from "styled-components";

export const FormContainer = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 20px;
  .form-control {
    display: block;
    width: 100%;
    margin-top: 0px !important;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    height: 56px !important;
    font-weight: 400;
    line-height: 1.5;
    color: ${(props) => props.theme.textColor.primary};
    background-color: ${(props) => props.theme.backgroundColor.primary};

    background-clip: padding-box;
    border: 1px solid ${(props) => props.theme.borderColor.primary} !important;
    border-radius: 13px !important;
  }
  *:focus {
    box-shadow: none !important;
  }
  .nav-tabs {
    font-size: 16px;
  }

  @media (max-width: 767.98px) {
    .nav-tabs {
      font-size: 10px;
    }
  }
  .extra_product_text {
    margin: 12px 10px 0px 12px;
    font-family: "Inter";
    font-size: 14px;
    font-weight: 500;
    color: ${(props) => props.theme.textColor.secondary};
  }
  input[type="checkbox"] {
    width: 16px;
    height: 15px;
    accent-color: ${(props) => props.theme.primaryColor.primary};
  }

  .product_image_container {
    width: 150px;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${(props) => props.theme.backgroundColor.primary};
    border: 1px solid ${(props) => props.theme.borderColor.primary} !important;
    border-radius: 15px;
    margin: 10px 0px 0px 23px;
  }

  @media (max-width: 767.98px) {
    .product_image_container {
      width: 100%;
      margin: 10px 0 0 0;
    }
  }
  .nav-tabs .nav-item.show .nav-link,
  .nav-tabs .nav-link.active {
    color: ${(props) => props.theme.primaryColor.primary} !important;
    background-color: ${(props) => props.theme.backgroundColor.secondary};
    border-color: ${(props) => props.theme.backgroundColor.secondary}
      ${(props) => props.theme.backgroundColor.secondary}
      ${(props) => props.theme.primaryColor.primary};
  }
  .nav-tabs .nav-link {
    font-family: "Inter" !important;
    font-weight: 600;
    color: ${(props) => props.theme.textColor.primary} !important;
  }
`;
